<template>
<div class="auth-wrapper">
    <div class="all-wrapper menu-side with-pattern">
        <div class="auth-box-w" v-if="formMode == 'login'">
            <div class="logo-w">
                <a><img alt="" src="/img/sb-logo-dark.svg"></a>
            </div>
            <!-- <li class="Row" style="padding-left: 75px;padding-right: 75px;">
            <div class="OpenIdLoginModule"><div id="googleOauthButton" class="oauth-google">
    <div class="oauth-google-inner" @click="handleSocialLogin('google')" >
      <img src="https://www.evernote.com/redesign/OpenID/img/GGL_logo_googleg_18.png">
      <div class="oauth-google-text">Continue with Google</div>
    </div>
  </div>
  <div class="inline" id="oauth-error">
    </div>
  <div class="inline oauth-message">
    </div>
</div></li>
            <li class="Row horizontalRow" style="padding-left: 75px;padding-right: 75px;">
              <div class="horizontalText">or</div>
              <div class="horizontalLine"></div>
            </li> -->
            <form @submit.prevent>
                <div class="form-group" :class="{'has-error has-danger': hasError == true}">
                    <input class="form-control" placeholder="Enter your email" type="text" v-model="user.email" @input="step = 'user_auth'">
                </div>
                <div class="form-group" :class="{'has-error has-danger': hasError == true, 'hidden': 1==1}" v-if="step == 'pass_auth'">
                    <input ref="password" class="form-control" placeholder="Enter your password" type="password" v-model="user.password">
                </div>
                <div class="buttons-w" >
                    <button class="btn btn-primary" style="width: 100%" v-if="step == 'pass_auth'" @click="handleLogin">Log me in</button>
                    <button class="btn btn-primary" style="width: 100%" v-if="step == 'user_auth'" @click="handleUserAuth">Continue</button>
                </div>
                <div class="buttons-w">
                    <a @click="formMode = 'reset'" class="blue">Reset my password</a>
                </div>
            </form>
        </div>
        <div class="auth-box-w" v-if="formMode == 'reset'">
            <div class="logo-w">
                <a><img alt="" src="/img/sb-logo-dark.svg"></a>
            </div>
            <h4 class="auth-header">
                Reset Password
            </h4>
            <form @submit.prevent="handleReset">
                <div class="form-group" :class="{'has-error has-danger': hasError == true}">
                    <label for="">Email</label>
                    <input class="form-control" placeholder="superadmin@teamstudiobridge.com" type="text" v-model="user.email">
                    <div class="pre-icon os-icon os-icon-user-male-circle"></div>
                </div>
                <div class="buttons-w">
                    <button class="btn btn-primary">Reset Password</button>
                </div>
                <div class="buttons-w">
                    <a @click="formMode = 'login'" class="blue">Back to login</a>
                </div>
            </form>
        </div>
    </div>
</div>
</template>

<style scoped>
.auth-wrapper {
    margin-top: -54px !important;
}
</style>

<script>
export default {
  props: ['formModeProp'],
  data () {
    return {
      hasError: false,
      formMode: 'login',
      step: 'user_auth',
      user: {
        email: '',
        password: ''
      }
    }
  },
  created () {
    if (this.formModeProp == 'reset') {
      this.formMode = this.formModeProp
    }
  },
  methods: {
    handleSocialLogin (network) {
      var self = this
      const hello = this.hello
      // hello(network).logout().then(function() {
      //     alert('Signed out');
      // }, function(e) {
      //     alert('Signed out error: ' + e.error.message);
      // });
      hello(network).login({
        scope: 'email',
        force: true,
        response_type: 'code'
      }).then(() => {
        const authRes = hello(network).getAuthResponse()
        console.log(authRes)

        const url = '/auth/sociallogin'
        self.$http.post(url, {
          access_token: authRes.access_token,
          provider: network
        },
        {
          dataType: 'json',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          }
        })
          .then(function (response) {
            if (response.data.token && response.data.token != null) {
              localStorage.setItem('token', response.data.token)
              self.$store.dispatch('resetState')
              self.$store.dispatch('loginUser', response.data)

              self.$http.get('/auth/profile')
                .then(function (response) {
                  self.$store.dispatch('updateUser', response.data)
                  self.$store.dispatch('updateOpenSessions', response.data.open_sessions)
                  self.$store.dispatch('updateClientVariables', response.data.variables)
                })

              self.$router.push('/')
            }
          })
          .catch(function (error) {
            console.log(error)
            self.hasError = true
            self.$store.dispatch('updateToast', { text: (error.response && error.response.data) || 'Something went wrong', show: true })
          })
      })
    },
    handleUserAuth: function () {
      var self = this
      const url = '/auth/provider'
      let data = {
        'username': self.user.email
      }
      self.hasError = false
      this.$http.post(url, data,
        {
          dataType: 'json',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          if (response.data.provider == 'google') {
            self.$store.dispatch('updateToast', { text: 'Please login with Google', show: true })
          }
          if (response.data.provider == 'password_auth') {
            self.step = 'pass_auth'
          } else {
            // redirect to idp
          }
        })
        .catch(function (error) {
          console.log(error)
          self.hasError = true
          self.$store.dispatch('updateToast', { text: (error.response && error.response.data) || 'Something went wrong', show: true })
        })
    },
    handleLogin: function () {
      var self = this
      const url = '/auth/login'
      let data = {
        'username': self.user.email,
        'password': self.user.password
      }
      self.hasError = false
      this.$http.post(url, data,
        {
          dataType: 'json',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          if (response.data.token && response.data.token != null) {
            localStorage.setItem('token', response.data.token)
            self.$store.dispatch('resetState')
            self.$store.dispatch('loginUser', response.data)

            self.$http.get('/auth/profile')
              .then(function (response) {
                self.$store.dispatch('updateUser', response.data)
                self.$store.dispatch('updateOpenSessions', response.data.open_sessions)
                self.$store.dispatch('updateClientVariables', response.data.variables)
              })

            self.$router.push('/')
          }
        })
        .catch(function (error) {
          console.log(error)
          self.hasError = true
          self.$store.dispatch('updateToast', { text: (error.response && error.response.data) || 'Something went wrong', show: true })
        })
    },
    handleReset: function () {
      var self = this
      const url = '/auth/password/reset'
      let data = {
        'email': self.user.email
      }
      self.hasError = false
      this.$http.post(url, data,
        {
          dataType: 'json',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.$store.dispatch('updateToast', { text: 'Password reset email sent', show: true })
          self.formMode = 'login'
        })
        .catch(function (error) {
          console.log(error)
          self.hasError = true
          self.$store.dispatch('updateToast', { text: (error.response && error.response.data) || 'Something went wrong', show: true })
        })
    }
  }

}
</script>

<style scoped>
.auth-box-w form {
    padding: 10px 80px;
    padding-bottom: 60px;
}
.form-control {
    height: 40px;
}
.blue {
    cursor: pointer;
    color: #047bf8 !important;
}

.auth-wrapper {
    background: url('https://pixinvent.com/demo/vuesax-vuejs-admin-dashboard-template/demo-1/img/vuesax-login-bg.04351a33.jpg')
}
.Row.horizontalRow {
    position: relative;
    margin-bottom: 18px;
    margin-top: 17px;
}
.Row:before, .Row:after {
    display: table;
    content: "";
}
.Row.horizontalRow .horizontalText {
    width: 100%;
    text-align: center;
    background-color: #ffffff;
    position: relative;
    color: #ababab;
    font-size: 14px;
    z-index: 1;
    overflow: hidden;
}
.Row:after {
    clear: both;
}
.Row:before, .Row:after {
    display: table;
    content: "";
}
.Row.horizontalRow .horizontalText:before {
    margin-left: -52%;
    text-align: right;
}
.Row.horizontalRow .horizontalText:before, .Row.horizontalRow .horizontalText:after {
    width: 50%;
    top: 51%;
    overflow: hidden;
    height: 1px;
    background-color: #d0d0d0;
    content: '\a0';
    position: absolute;
}
.Row.horizontalRow .horizontalText:after {
    margin-left: 2%;
}
.Row.horizontalRow .horizontalText:before, .Row.horizontalRow .horizontalText:after {
    width: 50%;
    top: 51%;
    overflow: hidden;
    height: 1px;
    background-color: #d0d0d0;
    content: '\a0';
    position: absolute;
}
.oauth-google {
    width: 300px;
    height: 40px;
    border-radius: 7px;
    border: solid 1px #d0d0d0;
    cursor: pointer;
    position: relative;
    z-index: 2;
    background-color: #ffffff;
    text-align: center;
    text-decoration: none !important;
    display: -moz-flex;
    display: -ms-flex;
    display: -webkit-flex;
    display: flex;
    -moz-flex-direction: column;
    -ms-flex-direction: column;
    -webkit-flex-direction: column;
    flex-direction: column;
    -webkit-flex-wrap: nowrap;
    -moz-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
    -moz-justify-content: center;
    -ms-justify-content: center;
    -webkit-justify-content: center;
    justify-content: center;
    -moz-flex-basis: auto;
    -webkit-flex-basis: auto;
    -ms-flex-basis: auto;
    flex-basis: auto;
}
.oauth-google .oauth-google-inner {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
}
.oauth-google .oauth-google-text {
    max-width: 280px;
    font-size: 15px;
    color: #6a6a6a;
    display: inline-block;
    position: relative;
    padding-left: 6px;
}
</style>
